<template>
  <section :class="{ 'mb-4': showPromoBanner }">
    <CHeader with-subheader class="header" style="position: fixed">
      <div class="promo-banner" v-if="showPromoBanner" @click="redirectToManagePlans">
        <span class="font-weight-bold">{{ $t('general.header.promo.welcome-1') }}</span> {{ $t('general.header.promo.welcome-2') }}
      </div>
      <div @click="$store.commit('toggleSidebarMobile')" class="facet_toggle">
        <CIcon
          style="margin-top: 20px; cursor: pointer"
          class="ml-2 mr-1"
          name="menuBurguer"
          :height="33"
          viewBox="0 0 32 32"
          @click="$store.commit('toggleSidebarMobile')"
        />
      </div>

      <div @click="$router.push({ name: 'home' })" class="py-2 d-flex flex-column justify-content-center" style="margin-left: 10px; cursor: pointer">
        <img :src="logoSrc" class="mr-3" style="width: 150px; height: 56px; object-fit: contain" />
      </div>
      <template v-if="$store.state.showBaseMenu">
        <ChooseOrganization class="organization-Wrapper p-2" />
      </template>
      <CHeaderNav class="ml-auto" v-if="$store.state.showUserControl">
        <template v-if="$store.state.showBaseMenu">
          <CHeaderNav class="d-md-down-none ml-auto">
            <CHeaderNavItem>
              <CHeaderNavLink :to="{ name: 'home' }" class="text-uppercase py-3 font-weight-normal text-decoration-none">
                {{ $t('general.header.navs.dashboard') }}
              </CHeaderNavLink>
            </CHeaderNavItem>
            <CDropdown placement="bottom-end" :caret="false" in-nav class="c-header-nav-item d-md-down-none mx-2" add-menu-classes="pt-0 mt-2">
              <template #toggler>
                <CHeaderNavLink
                  :class="
                    currentRouteName == 'audience' || currentRouteName == 'choose-methods' || currentRouteName == 'segments-list'
                      ? 'router-link-active'
                      : ''
                  "
                  class="text-uppercase py-3 font-weight-normal text-decoration-none"
                >
                  {{ $t('general.header.navs.audience') }}
                  <i class="fas fa-chevron-down font-xs ml-2 font-weight-normal"></i>
                </CHeaderNavLink>
              </template>
              <CDropdownItem class="" :to="{ name: 'audience' }">
                {{ $t('general.header.dropdownItems.audience') }}
              </CDropdownItem>
              <!--<CDropdownItem class="" :to="{ name: 'audience-dashboard' }">
                {{ $t('general.header.dropdownItems.audienceDashboard') }}
              </CDropdownItem>
               <CDropdownItem>
            Smart Audience
          </CDropdownItem> -->
              <CDropdownItem class="" :to="{ name: 'import-contacts' }">
                {{ $t('general.header.dropdownItems.createAudience') }}
              </CDropdownItem>
              <CDropdownItem class="" :to="{ name: 'segments-list' }">
                {{ $t('general.header.dropdownItems.segmentation') }}
              </CDropdownItem>
              <!-- <CDropdownItem>
            Export Data
          </CDropdownItem> -->
            </CDropdown>

            <CDropdown placement="bottom-end" :caret="false" in-nav class="c-header-nav-item d-md-down-none mx-2" add-menu-classes="pt-0 mt-2">
              <template #toggler>
                <CHeaderNavLink
                  class="text-uppercase py-3 font-weight-normal text-decoration-none"
                  :class="currentRouteName == 'campaign' || currentRouteName == 'campaignList' ? 'router-link-active' : ''"
                >
                  {{ $t('general.header.navs.campaign') }}
                  <i class="fas fa-chevron-down font-xs ml-2 font-weight-normal"></i>
                </CHeaderNavLink>
              </template>
              <CDropdownItem :to="{ name: 'campaign' }">
                {{ $t('sender.domainSender.domainSenderList.status.createNew') }}
              </CDropdownItem>
              <CDropdownItem :to="{ name: 'campaignList' }">
                {{ $t('sender.domainSender.domainSenderList.status.campaignList') }}
              </CDropdownItem>
            </CDropdown>

            <CDropdown placement="bottom-end" :caret="false" in-nav class="c-header-nav-item d-md-down-none mx-2" add-menu-classes="pt-0 mt-2">
              <template #toggler>
                <CHeaderNavLink
                  class="text-uppercase py-3 font-weight-normal text-decoration-none"
                  :class="currentRouteName == 'twoway-configuration' || currentRouteName == 'twoway-results' ? 'router-link-active' : ''"
                >
                  {{ $t('general.header.navs.2wm.navTitle') }}
                  <CBadge class="menu-flag" shape="pill" color="primary">{{ $t('general.header.navs.2wm.new') }}</CBadge>
                  <i class="fas fa-chevron-down font-xs ml-2 font-weight-normal"></i>
                </CHeaderNavLink>
              </template>
              <CDropdownItem :to="{ name: 'twoway-configuration' }">
                {{ $t('general.header.navs.2wm.configuration') }}
              </CDropdownItem>
              <CDropdownItem :to="{ name: 'twoway-results' }">
                {{ $t('general.header.navs.2wm.results') }}
              </CDropdownItem>
            </CDropdown>

            <CDropdown
              v-if="canAccessAutomation"
              placement="bottom-end"
              :caret="false"
              in-nav
              class="c-header-nav-item d-md-down-none mx-2"
              add-menu-classes="pt-0 mt-2"
            >
              <template #toggler>
                <CHeaderNavLink
                  class="text-uppercase py-3 font-weight-normal text-decoration-none"
                  :class="currentRouteName == 'automationNew' || currentRouteName == 'automationList' ? 'router-link-active' : ''"
                >
                  {{ $t('general.header.navs.automation.navTitle') }}
                  <i class="fas fa-chevron-down font-xs ml-2 font-weight-normal"></i>
                </CHeaderNavLink>
              </template>
              <CDropdownItem :to="{ name: 'automationNew' }">
                {{ $t('general.header.navs.automation.createNew') }}
              </CDropdownItem>
              <CDropdownItem :to="{ name: 'automationList' }">
                {{ $t('general.header.navs.automation.list') }}
              </CDropdownItem>
            </CDropdown>

            <CDropdown placement="bottom-end" :caret="false" in-nav class="c-header-nav-item d-md-down-none mx-2" add-menu-classes="pt-0 mt-2">
              <template #toggler>
                <CHeaderNavLink
                  class="text-uppercase py-3 font-weight-normal text-decoration-none"
                  :class="
                    currentRouteName == 'documentation' || currentRouteName == 'logs-trasactions' || currentRouteName == 'api-key'
                      ? 'router-link-active'
                      : ''
                  "
                >
                  {{ $t('general.header.navs.api') }}
                  <i class="fas fa-chevron-down font-xs ml-2 font-weight-normal"></i>
                </CHeaderNavLink>
              </template>

              <CDropdownItem :href="$configs.VUE_APP_DOCS_URL" target="blank">
                {{ $t('general.header.navs.transational-documentation') }}
              </CDropdownItem>
              <CDropdownItem class="" :to="{ name: 'logs-trasactions' }">
                {{ $t('general.header.navs.transational-transational-log') }}
              </CDropdownItem>
              <CDropdownItem class="" :to="{ name: 'api-key' }">
                {{ $t('general.header.navs.transational-apiKey') }}
              </CDropdownItem>
            </CDropdown>

            <!-- <CHeaderNavItem class="text-uppercase">
          <CHeaderNavLink to="/" exact class="text-uppercase py-3 font-weight-normal text-decoration-none">
            {{$t('general.INSIGHTS')}}
          </CHeaderNavLink>
        </CHeaderNavItem> -->

            <CDropdown placement="bottom-end" :caret="false" in-nav class="c-header-nav-item d-md-down-none mx-2" add-menu-classes="pt-0 mt-2">
              <template #toggler>
                <CHeaderNavLink
                  class="text-uppercase py-3 font-weight-normal text-decoration-none"
                  :class="currentRouteName == 'template-sms' || currentRouteName == 'template-emails' ? 'router-link-active' : ''"
                >
                  {{ $t('general.header.navs.templates') }}
                  <i class="fas fa-chevron-down font-xs ml-2 font-weight-normal"></i>
                </CHeaderNavLink>
              </template>
              <CDropdownItem class="" :to="{ name: 'template-sms' }">
                {{ $t('general.header.navs.smsTemplate') }}
              </CDropdownItem>
              <CDropdownItem class="" :to="{ name: 'template-emails' }">
                {{ $t('general.header.navs.emailTemplate') }}
              </CDropdownItem>
            </CDropdown>

            <!-- <CDropdown
          placement="bottom-end"
          :caret="false"
          in-nav
          class="c-header-nav-item d-md-down-none mx-2"
          add-menu-classes="pt-0 mt-2"
        >
        <template #toggler>
        <CHeaderNavLink>
          {{$t('general.MORE')}}
          <img src="img/site/set-down.png" class="icon-menu" />
        </CHeaderNavLink>
        </template>
        <CDropdownItem>
          Option 1
        </CDropdownItem>
        <CDropdownItem>
          Option 2
        </CDropdownItem>
        </CDropdown> -->
          </CHeaderNav>
        </template>
        <TheHeaderDropdownNotif />
        <TheHeaderDropdownAccnt />
      </CHeaderNav>
    </CHeader>
  </section>
</template>

<script>
import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt'
import TheHeaderDropdownNotif from './TheHeaderDropdownNotif'
import ChooseOrganization from '@/components/ChooseOrganization'
import { PLAN_TYPES } from '@/views/plansSubscriptions/constants.js'
import { checkFeatures, featuresEnum } from '@/utils/featureUtils'

export default {
  name: 'TheHeader',
  data() {
    return {
      canAccessAutomation: true,
    }
  },
  methods: {
    async chekHasAudience() {
      if (this.$store.state.auth.organizationId) {
        await this.$store.dispatch('audience/hasAudience', this.$store.state.auth.organizationId)
      }
    },

    isActive(pathString) {
      return this.$route.path.split('/')[1] == pathString ? 'router-link-exact-active router-link-active' : ''
    },
    redirectToManagePlans() {
      return this.$router.push({ name: 'manage-balance-plans' })
    },
  },
  created() {
    this.chekHasAudience()
  },

  mounted() {
    checkFeatures(featuresEnum.AUTOMATION).then((res) => (this.canAccessAutomation = res))
    if (this.$route.params.organizationId) {
      this.$store.commit('SHOW_BASE_MENU')
      return
    }
    this.$store.commit('HIDE_BASE_MENU', 'OrganizationSelection')
  },
  computed: {
    showPromoBanner() {
      return this.$store.state.auth.session?.organization?.planType == PLAN_TYPES.FREE
    },
    currentRouteName() {
      return this.$route.name
    },
    logoSrc() {
      return this.$store.state.whitelabel.whitelabelConfig?.logoUrl ?? '/img/logo-color.png'
    },
  },
  watch: {
    $route: {
      handler(newValue) {
        this.isActive(newValue)
      },
    },
  },
  components: {
    TheHeaderDropdownAccnt,
    ChooseOrganization,
    TheHeaderDropdownNotif,
  },
}
</script>

<style lang="scss" scoped>
.menu-flag {
  position: absolute;
  font-weight: bold;
  top: 10px !important;
  right: 7px !important;
}
.chooseOrganization__area {
  border-bottom: 1px solid var(--gray-600);
  z-index: 2039;
}
.header {
  .c-header-nav-link {
    letter-spacing: 1px;
    color: var(--gray-500);
    font-size: 13px;

    &:hover,
    &:focus,
    &.router-link-active {
      font-weight: bold;
      border-bottom: 3px solid #8b65b3;
    }
  }
}

.default-img {
  border: 1px solid var(--primary);
  color: white;
  background-color: $primary;
  width: 32px;
  height: 32px;
  text-align: center;
  font-size: 13px;
  font-weight: 600;
  line-height: 32px;
}

.organization-Wrapper {
  border-left: 1px solid #e9ecef;
  border-right: 1px solid #e9ecef;
}

.promo-banner {
  width: 100%;
  background-color: #a4dded;
  padding: 10px;
  text-align: center;
  cursor: pointer;
}
.promo-banner:hover {
  text-decoration: underline;
}

@media (min-width: 992px) {
  .facet_toggle {
    display: none;
  }
}
</style>
